import { faSearch, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactNode, useCallback, useState } from 'react';
import styled from 'styled-components';
import { BoldSmallBodyText, Dropdown, FlexRow, IDropdownAnchor, TinyBodyText } from 'ui-toolkit';
import { FilterCard } from './FilterCard';

export interface IClickToViewTableHeaderProps {
  text: ReactNode | string;
  filterText: ReactNode | string;
  filterComponent: ReactNode;
  onFilterDone: () => void;
  anchor?: IDropdownAnchor;
  sortItem?: ReactNode;
  icon?: IconDefinition;
}

const RelativeFlexRow = styled(FlexRow)`
  position: relative;
  padding: ${(props) => props.theme.spacing.spacing2};
  padding-left: ${(props) => props.theme.spacing.spacing4};
`;

export const DropdownSubstrate = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const ClickToViewTableHeader: React.FC<IClickToViewTableHeaderProps> = ({
  text,
  filterText,
  filterComponent,
  onFilterDone,
  anchor = IDropdownAnchor.bottomRight,
  sortItem,
  icon = faSearch,
}) => {
  const [showFilterComponent, setShowFilterComponent] = useState<boolean>(false);
  const closeDropdown = useCallback(() => {
    setShowFilterComponent(false);
    onFilterDone();
  }, [setShowFilterComponent, onFilterDone]);
  const openDropdown = useCallback(() => setShowFilterComponent(true), [setShowFilterComponent]);

  return (
    <>
      {showFilterComponent && <DropdownSubstrate onClick={closeDropdown} />}
      <RelativeFlexRow justifyContent={'space-between'} onKeyDown={(e) => (e.key === 'Enter' ? closeDropdown() : '')}>
        <FlexRow onClick={openDropdown}>
          {typeof text === 'string' ? (
            <>
              {filterComponent && <FontAwesomeIcon icon={icon} />} <BoldSmallBodyText>{text}</BoldSmallBodyText>
            </>
          ) : (
            text
          )}
          {typeof filterText === 'string' ? <TinyBodyText>{filterText}</TinyBodyText> : filterText}
        </FlexRow>
        {sortItem}
        <Dropdown show={showFilterComponent} anchor={anchor} isInline>
          <FilterCard>{filterComponent}</FilterCard>
        </Dropdown>
      </RelativeFlexRow>
    </>
  );
};
